/* FeaturedCard.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["to"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _65 = "._k48p1nn1{font-weight:400}";
const _64 = "._vwz41m1q{line-height:1.75rem}";
const _63 = "._1wpz1fhb{align-self:stretch}";
const _62 = "._4cvr1y6m{align-items:flex-start}";
const _61 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _60 = "@media not all and (min-width:90rem){._zzrmmgvx{width:180px}._1gdlmgvx{height:180px}}";
const _59 = "@media not all and (min-width:48rem){._1rfm1w81{width:150px}._tnru1w81{height:150px}}";
const _58 = "._1bsb1arc{width:8.75rem}";
const _57 = "._4t3i18r4{height:8.625rem}";
const _56 = "._qrwqv47k{border-top-right-radius:var(--ds-space-250,20px)}";
const _55 = "._13liv47k{border-top-left-radius:var(--ds-space-250,20px)}";
const _54 = "._1ygb1a9f:focus-visible{outline:var(--_1kmg6zk)}";
const _53 = "._1bsb1osq{width:100%}";
const _52 = "._2lx21bp4{flex-direction:column}";
const _51 = "._16qs171x{box-shadow:var(--_1lh16lc)}";
const _50 = "._zulpze3t{gap:var(--ds-space-0,0)}";
const _49 = "._19itkxja{border:var(--_1aje98t)}";
const _48 = "._11q7hp5a{background:var(--ds-surface-raised,#fff)}";
const _47 = "._18m915vq{overflow-y:hidden}";
const _46 = "._1reo15vq{overflow-x:hidden}";
const _45 = "._2rkov47k{border-radius:var(--ds-space-250,20px)}";
const _44 = "._4cvr1h6o{align-items:center}";
const _43 = "._1bah1h6o{justify-content:center}";
const _42 = "._1bsb11ux{width:140px}";
const _41 = "._4t3i11ux{height:140px}";
const _40 = "._18u01wug{margin-left:auto}";
const _39 = "._2hwx1wug{margin-right:auto}";
const _38 = "._bfhk11bn{background-color:var(--ds-background-accent-gray-subtlest,#f1f2f4)}";
const _37 = "._qrwqpxbi{border-top-right-radius:var(--ds-space-200,1pc)}";
const _36 = "._13lipxbi{border-top-left-radius:var(--ds-space-200,1pc)}";
const _35 = "@media (min-width:64rem){._1yagxy5q{padding:var(--ds-space-400,2pc)}}";
const _34 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const _33 = "._1di61a0f:active{background-color:var(--ds-surface-raised-hovered,#f1f2f4)}";
const _32 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _31 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _30 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _29 = "._1dbz1cd0:hover{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _28 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _27 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _26 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _25 = "._1ejj1cd0:focus-visible{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _24 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _23 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _22 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _21 = "._1ygbi3y1:focus-visible{outline:var(--ds-space-025,2px) solid var(--ds-border-focused,#388bff)}";
const _20 = "._bfhkhp5a{background-color:var(--ds-surface-raised,#fff)}";
const _19 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _18 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _17 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _16 = "._v56416gf{transition:box-shadow .2s ease-in-out}";
const _15 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _14 = "._2rkopxbi{border-radius:var(--ds-space-200,1pc)}";
const _13 = "@media (min-width:48rem) and (max-width:63.99rem){._1os2idpf{flex-grow:0}._8os5idpf{flex-shrink:0}._16xt1jta{flex-basis:calc(50% - var(--ds-space-800, 64px))}}";
const _12 = "@media not all and (min-width:48rem){._1fe7idpf{flex-grow:0}._12ihidpf{flex-shrink:0}._1a1x12n7{flex-basis:calc(75% - var(--ds-space-200, 16px))}}";
const _11 = "._1e0c1txw{display:flex}";
const _10 = "._18u0idpf{margin-left:0}";
const _9 = "._otyridpf{margin-bottom:0}";
const _8 = "._2hwxidpf{margin-right:0}";
const _7 = "._19pkidpf{margin-top:0}";
const _6 = "._i0dli9or{flex-basis:28%}";
const _5 = "._1o9zidpf{flex-shrink:0}";
const _4 = "._16jlidpf{flex-grow:0}";
const _3 = "._qtt8glyw{list-style:none}";
const _2 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _ = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal, BodySmall, H4 } from '@atlassian/mpac-primitives';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RefForwardingLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      to
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  let isExternalURL = false;
  let isAbsoluteURL = false;
  try {
    const newUrl = new URL(to);
    isExternalURL = newUrl.origin !== location.origin;
    isAbsoluteURL = true;
  } catch (e) {
    isExternalURL = false;
    isAbsoluteURL = false;
  }
  if (isExternalURL || isAbsoluteURL) {
    return /*#__PURE__*/_jsx("a", _objectSpread({
      ref: ref,
      href: to,
      target: isExternalURL ? '_blank' : undefined,
      rel: isExternalURL ? 'noopener noreferrer' : undefined,
      "aria-label": isExternalURL ? "Open ".concat(props['aria-label'] || 'external link', " in new tab") : props['aria-label']
    }, props));
  }
  return /*#__PURE__*/_jsx(Link, _objectSpread({
    innerRef: ref,
    to: to
  }, props));
});
RefForwardingLink.displayName = 'RefForwardingLink';
const Description = /*#__PURE__*/forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pku2gc _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const ListItem = /*#__PURE__*/forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt8glyw _16jlidpf _1o9zidpf _i0dli9or _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1fe7idpf _12ihidpf _1a1x12n7 _1os2idpf _8os5idpf _16xt1jta", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ListItem.displayName = 'ListItem';
}
const Card = /*#__PURE__*/forwardRef((_ref4, __cmplr) => {
  let {
      as: C = RefForwardingLink,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkopxbi _19itzgxb _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhkhp5a _1ygbi3y1 _vjfr18uv _10xfglyw _1w0vnqa1 _1ejj1cd0 _9oik18uv _1bnxglyw _jf4cnqa1 _1dbz1cd0 _1nrm18uv _c2waglyw _1iohnqa1 _1di61a0f", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const ContentWrapper = /*#__PURE__*/forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _35]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41ejb _1yagxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentWrapper.displayName = 'ContentWrapper';
}
const ImageContainer = /*#__PURE__*/forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _36, _37, _38]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41ejb _13lipxbi _qrwqpxbi _bfhk11bn", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const ImageWrapper = /*#__PURE__*/forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _39, _9, _40, _41, _42, _11, _43, _44]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _4t3i11ux _1bsb11ux _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ImageWrapper.displayName = 'ImageWrapper';
}
const CardStyle = null;
const ContentWrapperStyle = null;
const ImageContainerStyle = null;
const ImageWrapperStyle = null;
const ImageStyle = null;
const H4Style = null;
const DescriptionStyle = null;
export const FeaturedCard = /*#__PURE__*/forwardRef((_ref8, ref) => {
  let {
    title,
    description,
    image,
    navigationUrl,
    ariaHidden,
    tabIndex,
    ariaLabel
  } = _ref8;
  const {
    trackFeaturedCollectionClick
  } = useHomepageAnalytics();
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_45, _46, _47, _48, _49, _16, _17, _18, _19, _50, _51, _11, _52, _53, _44, _54, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33]
        }), /*#__PURE__*/_jsxs(RefForwardingLink, {
          to: navigationUrl,
          onClick: () => trackFeaturedCollectionClick(title),
          ref: ref,
          tabIndex: tabIndex,
          "aria-label": ariaLabel,
          className: ax(["_2rkov47k _1reo15vq _18m915vq _11q7hp5a _19itkxja _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulpze3t _16qs171x _1e0c1txw _2lx21bp4 _1bsb1osq _4cvr1h6o _1ygb1a9f _vjfr18uv _10xfglyw _1w0vnqa1 _1ejj1cd0 _9oik18uv _1bnxglyw _jf4cnqa1 _1dbz1cd0 _1nrm18uv _c2waglyw _1iohnqa1 _1di61a0f"]),
          style: {
            "--_1lh16lc": ix("0rem 0rem 0.0625rem 0rem ".concat("var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)", ", 0rem 0.0625rem 0rem 0rem ", "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)")),
            "--_1aje98t": ix("0.0625rem solid ".concat("var(--ds-border, #091E4224)")),
            "--_1kmg6zk": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"))
          },
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_34, _11, _52, _44, _55, _56, _53, _38]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_1yt41ejb _1e0c1txw _2lx21bp4 _4cvr1h6o _13liv47k _qrwqv47k _1bsb1osq _bfhk11bn"]),
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_7, _39, _9, _40, _57, _58, _11, _43, _44]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _4t3i18r4 _1bsb1arc _1e0c1txw _1bah1h6o _4cvr1h6o"]),
                  children: /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_59, _60]
                    }), /*#__PURE__*/_jsx("img", {
                      src: image,
                      alt: ariaHidden ? '' : title,
                      className: ax(["_1rfm1w81 _tnru1w81 _zzrmmgvx _1gdlmgvx"])
                    })]
                  })
                })]
              })
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_34, _61, _52, _62, _11, _63, _35]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1yt41ejb _zulpu2gc _2lx21bp4 _4cvr1y6m _1e0c1txw _1wpz1fhb _1yagxy5q"]),
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_64]
                }), /*#__PURE__*/_jsx(H4, {
                  as: "h3",
                  className: ax(["_vwz41m1q"]),
                  children: title
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_65]
                }), /*#__PURE__*/_jsx(BodyNormal, {
                  className: ax(["_k48p1nn1"]),
                  children: description
                })]
              })]
            })]
          })]
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsxs(Card, {
      to: navigationUrl,
      onClick: () => trackFeaturedCollectionClick(title),
      ref: ref,
      tabIndex: tabIndex,
      "aria-label": ariaLabel,
      children: [/*#__PURE__*/_jsx(ImageContainer, {
        children: /*#__PURE__*/_jsx(ImageWrapper, {
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_59, _60]
            }), /*#__PURE__*/_jsx("img", {
              src: image,
              alt: ariaHidden ? '' : title,
              className: ax(["_1rfm1w81 _tnru1w81 _zzrmmgvx _1gdlmgvx"])
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(ContentWrapper, {
        children: [/*#__PURE__*/_jsx(H4, {
          as: "h3",
          children: title
        }), /*#__PURE__*/_jsx(Description, {
          children: description
        })]
      })]
    })
  });
});
FeaturedCard.displayName = 'FeaturedCard';
export { RefForwardingLink };